export default __webpack_public_path__ + "static/media/login-bg-43.46197ef9.jpg";